import { IconButton } from "~/components/reusable/Button"
import { ShortcutTooltip } from "~/components/reusable/ShortcutTooltip"
import { HOTKEYS } from "~/constants/hotkeys"
import InspectorToggleIcon from "~/components/design-system/pages/internal/InspectorToggleIcon"
import { useInspectorContext } from "~/components/design-system/pages/internal/InspectorContext"

/**
 * Toggles the Module inspector. Rendered in the ViewConfiguration toolbar when present,
 * and as a fallback in the tabs row (right side) when a Module has an inspector but no
 * ViewConfiguration. Renders nothing when no inspector is registered.
 */
const InspectorToggleButton = () => {
  const { inspector, isOpen, toggle } = useInspectorContext()
  if (!inspector) return null

  return (
    <ShortcutTooltip
      label={isOpen ? "Hide inspector" : "Show inspector"}
      shortcut={HOTKEYS.inspectHoveredRow.hotkey}
    >
      <IconButton size="sm" variant="neutral" onClick={toggle} aria-label="Toggle inspector">
        <InspectorToggleIcon isOpen={isOpen} />
      </IconButton>
    </ShortcutTooltip>
  )
}

export default InspectorToggleButton
